import React from "react";
import "../Assets/css/index.css";
import { Link } from "react-router-dom";
import { Nav, Navbar } from "react-bootstrap";


function PolicyNavbar() {
    return (
        <>
            <div className="row-nav-profile">
                <Navbar expand="lg">
                    <div className="MainContainerPadding">
                        <Navbar.Toggle
                            aria-controls="basic-navbar-nav"
                            className="ms-auto"
                        />
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav className="me-auto">
                                <Link to="/privacy-policy" className="nav-link">
                                    Privacy Policy
                                </Link>
                                <Link to="#" className="nav-link">
                                    Terms & Conditions
                                </Link>
                                <Link to="#" className="nav-link">
                                    Copy Rights
                                </Link>
                                <Link to="#" className="nav-link">
                                    User Agreement
                                </Link>
                                <Link to="/cancellation-policy" className="nav-link">
                                    Cancellation Policy
                                </Link>
                            </Nav>
                        </Navbar.Collapse>
                    </div>
                </Navbar>
            </div>
        </>
    )
}

export default PolicyNavbar;